import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useOnlineStatus from '../hooks/useOnlineStatus'

/** Rotte accessibili senza rete (login / registrazione / report pubblico). */
function isPublicOfflinePath(pathname) {
  if (pathname === '/' || pathname === '/signup' || pathname === '/forgot-pwd') return true
  if (pathname === '/login') return true
  if (pathname.startsWith('/report-accident')) return true
  return false
}

/**
 * Con app offline, l’area autenticata è solo `/home` (add crash).
 * Le altre route vengono reindirizzate a `/home`.
 */
export default function OfflineNavigationGuard() {
  const isOnline = useOnlineStatus()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (isOnline) return
    const p = location.pathname
    if (isPublicOfflinePath(p)) return
    if (p === '/home') {
      if (location.state?.isHistoryOpen) {
        navigate('/home', {
          replace: true,
          state: { ...location.state, isHistoryOpen: false },
        })
      }
      return
    }
    navigate('/home', { replace: true, state: location.state })
  }, [isOnline, location.pathname, location.state, navigate])

  return null
}
